import { CHAT_ANALYTICS_EVENTS } from '@/lib/constants/post-message-types';
import { createSendTag } from '@/lib/send-tag';

/** Links a welcome-screen starter click to the message it sends, so it can carry the starter's id. */
const starterClick = createSendTag<string>();

export function setPendingStarterClick({ starterId, text }: { starterId: string; text: string }) {
  starterClick.set({ text, value: starterId });
}

export const consumeStarterIdFor = starterClick.consumeFor;

/**
 * A starter click's event, and the record that tags the message it sends: the same for a live tap
 * and for one made before the chat was ready and sent once it was.
 */
export function recordStarterClick({
  trackEvent,
  ...click
}: {
  trackEvent: (event: { event: string; properties?: Record<string, unknown> }) => void;
  starterId: string;
  text: string;
  position: number | undefined;
  isDated: boolean;
  isPinned: boolean;
  isRotating: boolean;
  audience: string | undefined;
  language: string;
}) {
  trackEvent({ event: CHAT_ANALYTICS_EVENTS.STARTER_CLICKED, properties: click });
  setPendingStarterClick({ starterId: click.starterId, text: click.text });
}
